import { render } from "./Event.vue?vue&type=template&id=307a8aa2&scoped=true"
import script from "./Event.vue?vue&type=script&lang=js"
export * from "./Event.vue?vue&type=script&lang=js"

import "./Event.vue?vue&type=style&index=0&id=307a8aa2&lang=css"
import "./Event.vue?vue&type=style&index=1&id=307a8aa2&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-307a8aa2"]])

export default __exports__